<script setup lang="ts">
import type VConsole from 'vconsole'
import gsap from 'gsap'

const { isMobile: isMobileBySSR } = useDevice()
const xs = useState('xs', () => isMobileBySSR)
const lg = computed(() => !xs.value)
let vConsole: VConsole

provide('APP_LAYOUT_MODE_XS', xs)
provide('APP_LAYOUT_MODE_LG', lg)

function setLayoutMode() {
  xs.value = isMobile() || window.innerWidth <= 780
}

function setRemUnit() {
  let fontSize = 100

  if (xs.value) {
    fontSize = (gsap.utils.clamp(0, 576, window.innerWidth) / 375) * 100
  }
  else {
    fontSize = (gsap.utils.clamp(1200, 1920, window.innerWidth) / 1920) * 100
  }
  document.documentElement.style.fontSize = `${fontSize}px`
}

onBeforeMount(() => {
  // rem
  watch(xs, setRemUnit, { immediate: true })
  // vconsole
  if (import.meta.dev && xs.value) {
    import('vconsole').then(({ default: VConsole }) => {
      vConsole = new VConsole()
    })
  }
  if (import.meta.client) {
    document.body.style.visibility = 'initial'
    nextTick(() => {
      document.body.classList.add('bgTransition')
    })
  }
})

onMounted(() => {
  setLayoutMode()
  window.addEventListener('resize', setRemUnit)
  window.addEventListener('resize', setLayoutMode)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', setRemUnit)
  window.removeEventListener('resize', setLayoutMode)
  vConsole?.destroy()
})
</script>

<template>
  <slot :xs="xs" :lg="lg" />
</template>
